import { useState } from 'react';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Tooltip
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import LinkClicksChartHeader from './LinkClicksChartHeader';
import { HOUR, MINUTE } from '../../../../constants';
import { useTranslation } from 'react-i18next';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const PERIOD_OPTIONS = [
  { value: HOUR, labelKey: 'linkClicks.hour' },
  { value: MINUTE, labelKey: 'linkClicks.minute' }
];

const ClicksByDaytime = ({ daytime }) => {
  const [period, setPeriod] = useState(HOUR);
  const { t, i18n } = useTranslation();
  const isHourPeriod = period === HOUR;
  const slots = daytime[period];

  const formatHour = new Intl.DateTimeFormat(i18n.language, {
    hour: 'numeric'
  }).format;
  const labels = isHourPeriod
    ? slots.map(({ hour }) => formatHour(new Date(2000, 0, 1, hour)))
    : slots.map(({ minute }) => String(minute).padStart(2, '0'));

  const data = {
    labels,
    datasets: [
      {
        label: t('linkClicks.linkClicks'),
        data: slots.map(({ clicks }) => clicks),
        backgroundColor: '#3a83f6',
        borderRadius: 2,
        borderSkipped: false,
        maxBarThickness: 14
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false } },
    scales: {
      x: {
        grid: { display: false },
        border: { display: false },
        ticks: {
          color: '#3e4957',
          autoSkip: false,
          font: { size: 10 },
          callback(value, index) {
            if (!isHourPeriod) return labels[index];
            return index % 3 === 0 || index === labels.length - 1
              ? labels[index]
              : '';
          }
        }
      },
      y: {
        beginAtZero: true,
        grid: { color: '#ebebeb' },
        border: { display: false },
        ticks: { color: '#3e4957', font: { size: 10 } }
      }
    }
  };

  return (
    <section className="bg-white rounded-4 p-3 p-md-4">
      <LinkClicksChartHeader
        title={t('linkClicks.clicksByDaytime')}
        description={t('linkClicks.clicksByDaytimeDescription')}
        options={PERIOD_OPTIONS.map(({ value, labelKey }) => ({ value, label: t(labelKey) }))}
        activeOption={period}
        onOptionChange={setPeriod}
      />
      <div className="link-clicks-daytime-chart">
        <Bar data={data} options={options} aria-label={t('linkClicks.clicksByDaytime')} />
      </div>
    </section>
  );
};

export default ClicksByDaytime;
